(function () {
  var HYPOTHESIS_ID = '019efcd6-a756-7656-94fd-fa744f9777d2';

  // Desktop-only guard. 769px is the theme's `medium-up` breakpoint (theme.css.liquid).
  // Shoplift dashboard device targeting already excludes mobile from bucketing; this is
  // defense-in-depth so the mobile DOM is never mutated even if the script runs.
  function isDesktop() {
    return window.matchMedia && window.matchMedia('(min-width: 769px)').matches;
  }

  function applyTreatment() {
    // The desktop search icon is the one WITHOUT `medium-up--hide` (that class marks the
    // mobile-only instance in header-icons.liquid for the center-aligned layout).
    var search = document.querySelector('.js-search-header:not(.medium-up--hide)');
    var userIcon = document.querySelector('.site-nav__icons .icon-user');
    var userLink = userIcon ? userIcon.closest('a') : null;
    if (!search || !userLink || !userLink.parentNode) return;

    // Move the live node so its existing search-drawer click binding is preserved.
    userLink.parentNode.insertBefore(search, userLink);
  }

  function check(attempts) {
    if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
      window.shoplift.isHypothesisActive(HYPOTHESIS_ID).then(function (isVariant) {
        if (isVariant) applyTreatment();
      }).catch(function () { /* assignment failed -> control experience, no-op */ });
      return;
    }
    if (attempts < 50) setTimeout(function () { check(attempts + 1); }, 100);
  }

  if (isDesktop()) check(0);
})();
